import { Component } from '@wix/thunderbolt-becky-types'
import { FeatureRefs } from '../cssFeatures.types'
import { createCssCompNode } from '../cssCompNode'
import { CompData } from '@wix/thunderbolt-becky-root'
import { envRefs } from '@wix/thunderbolt-catharsis'

export const meshChild = (isEditor: boolean) =>
	createCssCompNode('mesh', 'meshChild', {
		getDependencies: (component: Component, refs: FeatureRefs<'mesh'>) => {
			const deps =
				component.componentType === 'Column'
					? {
							compData: ({
								props: refs.propertyQuery(component.propertyQuery!),
								style: refs.styleId(component.styleId!),
								data: refs.dataQuery(component.dataQuery!),
							} as unknown) as CompData,
							autoHeightWrapper: isEditor ? refs.autoHeightWrapper?.(component) : false,
							children: (component.components || []).map(refs.meshChild),
					  }
					: {
							autoHeightWrapper: isEditor ? refs.autoHeightWrapper?.(component) : false,
							children: (component.components || []).map(refs.meshChild),
					  }
			return {
				...deps,
				isMobileView: envRefs.isMobileView,
			}
		},
		toViewItem: (component, deps) => {
			return {
				component,
				...deps,
			}
		},
	})
